export default {
  GET_POSSIBLE_RESERVE_DATES_LOADING: 'GET_POSSIBLE_RESERVE_DATES_LOADING',
  GET_POSSIBLE_RESERVE_DATES_SUCCESS: 'GET_POSSIBLE_RESERVE_DATES_SUCCESS',
  GET_POSSIBLE_RESERVE_DATES_FAILED: 'GET_POSSIBLE_RESERVE_DATES_FAILED',
  GET_POSSIBLE_RESERVE_DATES_REJECT: 'GET_POSSIBLE_RESERVE_DATES_REJECT',

  GET_POSSIBLE_RESERVE_TABLES_LOADING: 'GET_POSSIBLE_RESERVE_TABLES_LOADING',
  GET_POSSIBLE_RESERVE_TABLES_SUCCESS: 'GET_POSSIBLE_RESERVE_TABLES_SUCCESS',
  GET_POSSIBLE_RESERVE_TABLES_FAILED: 'GET_POSSIBLE_RESERVE_TABLES_FAILED',
  GET_POSSIBLE_RESERVE_TABLES_REJECT: 'GET_POSSIBLE_RESERVE_TABLES_REJECT',

  CREATE_NEW_RESERVE_LOADING: 'CREATE_NEW_RESERVE_LOADING',
  CREATE_NEW_RESERVE_SUCCESS: 'CREATE_NEW_RESERVE_SUCCESS',
  CREATE_NEW_RESERVE_FAILED: 'CREATE_NEW_RESERVE_FAILED',
  CREATE_NEW_RESERVE_REJECT: 'CREATE_NEW_RESERVE_REJECT',

  CANCEL_RESERVE_LOADING: 'CANCEL_RESERVE_LOADING',
  CANCEL_RESERVE_SUCCESS: 'CANCEL_RESERVE_SUCCESS',
  CANCEL_RESERVE_FAILED: 'CANCEL_RESERVE_FAILED',
  CANCEL_RESERVE_REJECT: 'CANCEL_RESERVE_REJECT',

  RESERVE_PAYMENT_LOADING: 'RESERVE_PAYMENT_LOADING',
  RESERVE_PAYMENT_SUCCESS: 'RESERVE_PAYMENT_SUCCESS',
  RESERVE_PAYMENT_FAILED: 'RESERVE_PAYMENT_FAILED',
  RESERVE_PAYMENT_REJECT: 'RESERVE_PAYMENT_REJECT',

  GET_MY_RESERVES_LOADING: 'GET_MY_RESERVES_LOADING',
  GET_MY_RESERVES_SUCCESS: 'GET_MY_RESERVES_SUCCESS',
  GET_MY_RESERVES_FAILED: 'GET_MY_RESERVES_FAILED',
  GET_MY_RESERVES_REJECT: 'GET_MY_RESERVES_REJECT',

  GET_MY_RESERVE_DETAILS_LOADING: 'GET_MY_RESERVE_DETAILS_LOADING',
  GET_MY_RESERVE_DETAILS_SUCCESS: 'GET_MY_RESERVE_DETAILS_SUCCESS',
  GET_MY_RESERVE_DETAILS_FAILED: 'GET_MY_RESERVE_DETAILS_FAILED',
  GET_MY_RESERVE_DETAILS_REJECT: 'GET_MY_RESERVE_DETAILS_REJECT',

  CANCEL_PAID_RESERVE_LOADING: 'CANCEL_PAID_RESERVE_LOADING',
  CANCEL_PAID_RESERVE_SUCCESS: 'CANCEL_PAID_RESERVE_SUCCESS',
  CANCEL_PAID_RESERVE_FAILED: 'CANCEL_PAID_RESERVE_FAILED',
  CANCEL_PAID_RESERVE_REJECT: 'CANCEL_PAID_RESERVE_REJECT',

  APPLY_DISCOUNT_CODE_LOADING: 'APPLY_DISCOUNT_CODE_LOADING',
  APPLY_DISCOUNT_CODE_SUCCESS: 'APPLY_DISCOUNT_CODE_SUCCESS',
  APPLY_DISCOUNT_CODE_FAILED: 'APPLY_DISCOUNT_CODE_FAILED',
  APPLY_DISCOUNT_CODE_REJECT: 'APPLY_DISCOUNT_CODE_REJECT',
};
